(function() {
  var collectionData = JSON.parse(document.getElementById('collectionJson').textContent);
  const buildBoxBtns = document.querySelectorAll('.box-builder--add__button');
  const removeBoxBtns = document.querySelectorAll('.box-builder--remove__button');
  const selectionBox = document.querySelectorAll('[js-selection-box]');
  const addProductBtns = document.querySelectorAll('[js-quantity-increment]');
  const minusProductBtns = document.querySelectorAll('[js-quantity-decrement]');
  const variant_pills = document.querySelectorAll('.variant-pill');
  const salePrices = document.querySelectorAll('[js-product-price]');
  const comparePrices = document.querySelectorAll('[js-product-compare-price]');
  const addToCartBtn = document.querySelector('[js-box-addtocart-btn]');
  const addToCartBtnMobile = document.querySelector('[js-box-addtocart-mobile-btn]');
  const optionRadios = document.querySelectorAll('.product-item__option-radio');
  const discount = document.getElementById('box-discount').value;
  const discount_code = document.getElementById('box-discount-code').value;
  const discount_type = document.getElementById('box-discount-type').value;
  var boxItems = [];

  var boxIsFull = function() {
    return (boxItems.length > 2) ? true : false;
  }

  var btnsUpdate = function() {
    if(boxIsFull()) {
      buildBoxBtns.forEach(add_btn => {
        add_btn.disabled = true;
      });
      addProductBtns.forEach(plus_btn => {
        plus_btn.disabled = true;
      });
    } else {
      buildBoxBtns.forEach(add_btn => {
        add_btn.disabled = false;
      });
      addProductBtns.forEach(plus_btn => {
        plus_btn.disabled = false;
      });
    }
  }
  
  var infoUpdate = function() {
    document.querySelector('[js-selection-count]').innerHTML = boxItems.length + "/3";
    document.querySelector('[js-remaining-count]').innerHTML = 3 - boxItems.length;
    if(boxItems.length > 0) document.querySelector('[js-bundle-processing-msg]').classList.remove('hidden');
    else document.querySelector('[js-bundle-processing-msg]').classList.add('hidden');
    if(boxItems.length > 2) {
      document.querySelector('[js-bundle-processing-msg]').classList.add('hidden');
      document.querySelector('[js-bundle-completed-msg]').classList.remove('hidden');
      document.querySelector('[js-selection-count-wrapper]').classList.add('hidden');
      document.querySelector('[js-box-addtocart-btn]').classList.remove('hidden');
      comparePrices.forEach(compare_price => {
        compare_price.classList.remove('hidden');
      });
    } else {
      document.querySelector('[js-bundle-completed-msg]').classList.add('hidden');
      document.querySelector('[js-selection-count-wrapper]').classList.remove('hidden');
      document.querySelector('[js-box-addtocart-btn]').classList.add('hidden');
      comparePrices.forEach(compare_price => {
        compare_price.classList.add('hidden');
      });
    }
    if(boxItems.length < 2) {
      document.querySelector('[js-product-plural]').classList.remove('hidden');
    }
    else document.querySelector('[js-product-plural]').classList.add('hidden');
  }

  var infoUpdateMobile = function() {
    var mobileBox = document.querySelector('.box--mobile');
    mobileBox.querySelector('[js-selection-count]').innerHTML = boxItems.length + "/3";
    mobileBox.querySelector('[js-remaining-count]').innerHTML = 3 - boxItems.length;
    if(boxItems.length > 2) {
      mobileBox.querySelector('[js-bundle-processing-msg]').classList.add('hidden');
      mobileBox.querySelector('[js-bundle-completed-msg]').classList.remove('hidden');
      mobileBox.querySelector('[js-selection-count-wrapper]').classList.add('hidden');
      mobileBox.querySelector('[js-box-addtocart-btn]').classList.remove('hidden');
      comparePrices.forEach(compare_price => {
        compare_price.classList.remove('hidden');
      });
    } else {
      mobileBox.querySelector('[js-bundle-processing-msg]').classList.remove('hidden');
      mobileBox.querySelector('[js-bundle-completed-msg]').classList.add('hidden');
      mobileBox.querySelector('[js-selection-count-wrapper]').classList.remove('hidden');
      mobileBox.querySelector('[js-box-addtocart-btn]').classList.add('hidden');
      comparePrices.forEach(compare_price => {
        compare_price.classList.add('hidden');
      });
    }
    if(boxItems.length < 2) {
      mobileBox.querySelector('[js-product-plural]').classList.remove('hidden');
    }
    else mobileBox.querySelector('[js-product-plural]').classList.add('hidden');
  }

  var emptyBundleBox = function() {
    for(i = 0; i < 3; i++) {
      selectionBox[i].classList.remove('has-value');
      selectionBox[i].querySelector('.selected-bundle-info .title').textContent = "choose a product";
      selectionBox[i].querySelector('.selected-bundle-info .prices').textContent = "$0";
    }
  }
  

  var updateBundleBox = function(boxItems) {
    console.log("boxItems",boxItems)
    let bundleLength = boxItems.length > 3 ? 3 : boxItems.length;
    let totalPrice = 0;
    emptyBundleBox();
    for (i = 0; i < bundleLength; i++) {
      let boxItem = boxItems[i];
      let box_product_id = boxItem;
      let box_variant_id = '';
      if(boxItem.includes('_')){
        boxItem = boxItem.split('_');
        box_product_id = boxItem[0];
        box_variant_id = boxItem[1];
      }

      for(j = 0; j < collectionData.length; j++) {
        let product = collectionData[j];
        if(product.id == box_product_id) {
          let featured_image = product.featured_image;
          let title = product.title;
          let price = (product.price / 100);
          if(box_variant_id) {
            for(k = 0; k < product.variants.length; k++) {
              let variant = product.variants[k];
              if(variant.id == box_variant_id) {
                title = variant.name;
                price = (variant.price / 100);
                if(variant.featured_image) featured_image = variant.featured_image.src;
              }
            }
          }
          totalPrice += price;

          selectionBox[i].classList.add('has-value');
          selectionBox[i].querySelector('.selected-product-media img').src = featured_image;
          selectionBox[i].querySelector('.selected-bundle-info .title').textContent = title;
          selectionBox[i].querySelector('.selected-bundle-info .prices').textContent = "$" + price.toFixed(2);
        }
      }
    }

    let discountedPrice = "$" + (totalPrice - discount).toFixed(2);
    if(discount_type == 'percentage') {
      let discounted = totalPrice - (totalPrice * (discount/100));
      discountedPrice = "$" + discounted.toFixed(2);
    }
    let originalPrice = "$" + totalPrice.toFixed(2);
    if(boxItems.length <= 2) discountedPrice = originalPrice;
    salePrices.forEach(sale_price => {
      sale_price.innerHTML = discountedPrice;
    });
    
    comparePrices.forEach(compare_price => {
      compare_price.innerHTML = originalPrice;
    });
    
    infoUpdate();
    infoUpdateMobile();
    btnsUpdate();
  }
  
  buildBoxBtns.forEach(add_btn => {
    add_btn.onclick = function (e) {
      e.preventDefault();

      let productInfoEl = this.closest('.product-item--info');
      let productBoxCTA = this.closest('.box--cta');
      let product_id = this.dataset.productId;
      let variant_id = '';
      let item_id = product_id;
      productBoxCTA.classList.add('selected');
      
      boxItems.push(product_id);
      updateBundleBox(boxItems);
    }
  });

  optionRadios.forEach(optionRadio => {
    optionRadio.onchange = function (e) {
      let selectedOptions = [];
      let productItem = this.closest('.product-item');
      let parentSelector = this.closest('.product-item__variant-selector');
      let variantOptions = parentSelector.querySelectorAll('.product-item__variant-option');
      variantOptions.forEach(variantOption => {
        if(variantOption.querySelector('input[type="radio"]:checked')) selectedOptions.push(variantOption.querySelector('input[type="radio"]:checked').value);
      });
      let productData = (parentSelector.querySelector('script') ? JSON.parse(parentSelector.querySelector('script').textContent) : false);
      let selectedOption = selectedOptions.join(' / ');
      if(productData) {
        let productVariants = productData.variants;
        let selectedVariant = productVariants.find(obj => obj['title'] === selectedOption);
        if(selectedVariant) {
          let selectedVariantID = selectedVariant.id;
          console.log('selectedVariantID',selectedVariantID)
          productItem.querySelector('.box--cta:not(.hidden)').classList.add('hidden');
          productItem.querySelector(`.build-a-box--${selectedVariantID}`).classList.remove('hidden');
          if(productItem.querySelector(`.product-item__bg__inner.is-visible`)) productItem.querySelector(`.product-item__bg__inner.is-visible`).classList.remove('is-visible');
          productItem.querySelector(`.product-item__bg__inner[data-variant-title="${selectedOption}"]`).classList.add('is-visible');
        }
      }
    }
  });

  removeBoxBtns.forEach(remove_btn => {
    remove_btn.onclick = function (e) {
      e.preventDefault();

      let productInfoEl = this.closest('.product-item--info');
      let productBoxCTA = this.closest('.box--cta');
      let product_id = this.dataset.productId;
      productBoxCTA.classList.remove('selected');
      let box_product_id = product_id;
      
      for (let i = boxItems.length - 1; i >= 0 ; i--) {
        if(boxItems[i].includes(box_product_id)) {
          boxItems.splice(i, 1);
          break;
        }
      }
      updateBundleBox(boxItems);
    }
  });
  
  addProductBtns.forEach(add_btn => {
    add_btn.onclick = function (e) {
      e.preventDefault();

      let productInfoEl = this.closest('.box--cta');
      let product_id = this.dataset.productId;
      let variant_id = '';
      let item_id = product_id;
      let currentQty = productInfoEl.querySelector('.build-a-box--qty__input').value;
      productInfoEl.querySelector('.build-a-box--qty__input').value = ++currentQty;
      
      boxItems.push(product_id);
      updateBundleBox(boxItems);
    }
  });
  
  minusProductBtns.forEach(minus_btn => {
    minus_btn.onclick = function (e) {
      e.preventDefault();

      let productInfoEl = this.closest('.box--cta');
      let product_id = this.dataset.productId;
      let variant_id = '';
      let item_id = product_id;
      let currentQty = productInfoEl.querySelector('.build-a-box--qty__input').value;
      if(currentQty > 0) productInfoEl.querySelector('.build-a-box--qty__input').value = --currentQty;
      if(currentQty <= 0) productInfoEl.classList.remove('selected');
      
      for (let i = boxItems.length - 1; i >= 0 ; i--) {
        if(boxItems[i] == product_id) {
          boxItems.splice(i, 1);
          break;
        }
      }
      updateBundleBox(boxItems);
    }
  });

  variant_pills.forEach(function(pill) {
    pill.addEventListener("click", function(e) {
      const boxCTA = this.closest('.product-item--info').querySelectorAll('.box--cta');
      let variant_id = pill.getAttribute('data-variant');
      boxCTA.forEach(function(box_cta) {
        box_cta.classList.add('hidden');
      });
      document.querySelector('.build-a-box--'+variant_id).classList.remove('hidden');
    });
  });

  
  function addProducts(formData) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      document.querySelector('collection-component.collection-products').classList.add('build-box-disabled');
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  var addBoxToCart = function() {
    var items = [];
    for (let i = boxItems.length - 1; i >= 0 ; i--) {
      let boxItem = boxItems[i];
      boxItem = boxItem.split('_');
      let box_product_id = boxItem[0];
      let box_variant_id = boxItem[1];

      let uniqueId = Date.now();
      let item = {
        'id': box_variant_id,
        'quantity': 1,
        'properties': {
          '_box_builder': 'box_builder_' + uniqueId
        }
      }
      items.push(item);
    }
    let formData = {
     'items': items
    };
    if(discount_code) {
      fetch(`/discount/${discount_code}`, {
        method: 'GET'
      })
      .then(response => {
        addProducts(formData)
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {
      addProducts(formData)
    }
  }
  
  addToCartBtn.onclick = function (e) {
    e.preventDefault();
    addBoxToCart();
  }
  
  addToCartBtnMobile.onclick = function (e) {
    e.preventDefault();
    addBoxToCart();
  }
  
  function isHidden(el) {
    return (el.offsetParent === null)
  }
  
  if ($(window).width() <= 768) {
    document.addEventListener("scroll", (event) => {
      let lastKnownScrollPosition = window.scrollY;
      if(lastKnownScrollPosition > 400) {
        document.querySelector('.build-a-box--mobile').classList.remove('hidden');
      } else {
        document.querySelector('.build-a-box--mobile').classList.add('hidden');
      }
    });
  }
})();